import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Plaque extends Symbol2d {

  handles = [{
    defaults: [.115, 0],
    constraints: (dimensions) => {
      let max = Math.min(dimensions.width / 2, dimensions.height / 2) / dimensions.width
      return [
        [0.05, max], null
      ]
    },
    cursor: 'ew-resize'
  }]

  path (dimensions, handles) {
    const _path = path()

    const offset = dimensions.width * handles[0][0]

    _path.moveTo(offset, 0)
    _path.lineTo(dimensions.width - offset, 0)
    _path.arcTo(dimensions.width - offset, offset, dimensions.width, offset, offset)
    _path.lineTo(dimensions.width, dimensions.height - offset)
    _path.arcTo(dimensions.width - offset, dimensions.height - offset, dimensions.width - offset, dimensions.height, offset)
    _path.lineTo(offset, dimensions.height)
    _path.arcTo(offset, dimensions.height - offset, 0, dimensions.height - offset, offset)
    _path.lineTo(0, offset)
    _path.arcTo(offset, offset, offset, 0, offset)
    _path.closePath()

    return _path.toString()
  }

  textContainer(dimensions, handles) {
    const offset = dimensions.width * handles[0][0]

    // Slope of the line from the center to the top left corner
    const m = (dimensions.height / 2) / (dimensions.width / 2)
    const b = dimensions.center[1] - m * dimensions.center[0]

    const intersection = findIntersection(offset, m, b)

    const width = (dimensions.center[0] - intersection[0]) * 2
    const height = dimensions.height - (intersection[1] * 2)

    return {
      center: dimensions.center,
      width,
      height,
    }
  }
}

/*
 * Finds the intersection of a line with slope `m` and `y`-intercept `b` with a circle of radius `r`.
 * Assumumes the circle is centered at the origin.
 */
function findIntersection (r, m, b) {
  // Simplified coefficients for the quadratic equation of the circle and line
  const a = 1 + m * m
  const b2 = 2 * m * b
  const c = b * b - r * r

  // Calculate the discriminant
  const discriminant = b2 * b2 - 4 * a * c

  // Calculate x values for intersections
  const x1 = (-b2 + Math.sqrt(discriminant)) / (2 * a)
  const y1 = m * x1 + b

  return [x1, y1]
}
